import script from "./ScrollToTopButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScrollToTopButton.vue?vue&type=script&setup=true&lang=ts"

import "./ScrollToTopButton.vue?vue&type=style&index=0&id=2bf3420c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bf3420c"]])

export default __exports__